export default __webpack_public_path__ + "static/media/logo_monitoreo2.79c17218.png";